import React, { useEffect, useState, useContext } from "react";
import { BusinessContext } from "@rewardle/apps.auth.businessauthorization.businessauthorization";
import axios from "axios";
import CardContainer from "../../components/dashboard/Card";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import Analytics from "../../components/dashboard/Analytics";
import {
  Box as MuiBox,
  Typography as MuiTypography,
  CardActions as MuiCardActions,
  ButtonGroup as MuiButtonGroup,
  useMediaQuery,
  Card,
  Grid
} from "@mui/material";
import styled from "@emotion/styled";
import { formatDate } from "../../Utils/commonFunction";
import Loader from "../../components/loader/loader";
import firebase from "firebase";

const apibaseUrl = process.env.REACT_APP_API_BASE_URL;
const ButtonGroup = styled(MuiButtonGroup)(({ theme }) => ({
  display: "flex",
  width: 88,
  padding: "6px 18px",
  justifyContent: "center",
  alignItems: "center",
  gap: 10,
  borderRadius: 41,
  border: `1px solid `,
  cursor: "pointer",
  "& .MuiButton-root": {
    backgroundColor: "transparent"
  },
  "&.active": {
    background: "#192f671a"
  }
}));

const Box = styled(MuiBox)``;

const TypographyButtonSlectedValue = styled(MuiTypography)`
  color: #192f67;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
`;
const TypographySubTitile = styled(MuiTypography)`
  color: var(--light-text-secondary, rgba(0, 0, 0, 0.6));
  font-feature-settings: "clig" off, "liga" off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
const CartTitleTypography = styled(MuiTypography)`
  color: var(--light-text-dark, rgba(0, 0, 0, 0.88));
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const TypographyChartTitile = styled(MuiTypography)`
  color: #535353;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin-left: 15px;
`;

const Dashboard: React.FC = ({}) => {
  let currentBusiness: any = localStorage?.getItem("currentBusiness");
  const state: any = {
    token: localStorage?.getItem("businessAccessToken"),
    currentBusiness: currentBusiness ? JSON.parse(currentBusiness) : null
  };

  const isDesktop = useMediaQuery("(min-width:600px)");

  const BoxOption = styled(MuiBox)(({ theme }) => ({
    display: "flex",
    gap: "10px",
    flexWrap: isDesktop ? "nowrap" : "wrap",
    justifyContent: isDesktop ? "space-between" : "flex-start"
  }));

  const CardActions = styled(MuiCardActions)(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: isDesktop ? "row" : "column",
    justifyContent: "space-between",
    gap: isDesktop ? "0px" : "10px",
    alignItems: isDesktop ? "center" : "baseline"
  }));

  let [businessToken, setBusinessToken] = useState(state?.token);

  const [filterTransactionByName, setFilterTransactionByName] =
    useState("today");

  const [transactionData, setTransactionData] = useState<any>({});
  const [settlementData, setSettlementData] = useState<any>({});
  const [transactionLoading, setTransactionLoading] = useState({
    isTotalSalesLoading: true,
    isTotalTransactionsLoading: true,
    isSettlementLoading: true
  });

  const [chartFilterName, setChartFilterName] = useState("Sales");
  const [isTotalSalesLoading, setIsTotalSalesLoading] = React.useState(true);
  const [isSettlementLoading, setIsSettlementLoading] = React.useState(true);
  const [isTotalTransactionsLoading, setIsTotalTransactionsLoading] =
    React.useState(true);
  const [analyticsIsLoading, setAnalyticsIsLoading] = React.useState(false);

  const [configData, setConfigData] = useState<any>({ BusinessTimeZone: null });

  interface TooltipContext {
    series: number[][];
    seriesIndex: number;
    dataPointIndex: number;
    w: {
      globals: {
        [x: string]: any;
        tooltip: {
          enabled: boolean;
        };
      };
    };
  }

  const [options, setOptions] = useState({
    chart: {
      id: "apexchart-example",
      height: 350,
      type: "bar"
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        dataLabels: {
          position: "top"
        }
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: [],
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      crosshairs: {
        fill: {
          type: "gradient",
          gradient: {
            colorFrom: "#D8E3F0",
            colorTo: "#BED1E6",
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5
          }
        }
      }
    },
    yaxis: {
      labels: {
        formatter: function (value: any, index: any) {
          return value;
        }
      }
    },
    stroke: {
      width: 1
    },
    colors: ["#192F67", "#4CAF50", "#2196F3"],
    theme: {
      fontFamily: "Montserrat, sans-serif",
      fontSize: "14px"
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (value: number) => value.toString()
      },
      style: {
        fontSize: "12px"
      }
    },
    legend: {
      show: true,
      position: "top",
      fontSize: "14px",

      markers: {
        width: 10,
        height: 10
      }
    },
    grid: {
      show: true,
      borderColor: "#ddd",
      strokeDashArray: 5,
      padding: {
        left: 56
      }
    }
  });

  const [series, setSeries] = useState([
    {
      name: "",
      data: []
    }
  ]);

  useEffect(() => {
    let newOption = { ...options };
    newOption.tooltip.y = {
      formatter: (value: number) => {
        if (chartFilterName === "Transactions") return value.toString();
        else return `$${value.toFixed(2)}`;
      }
    };
    setOptions(newOption);
  }, [chartFilterName]);

  const getRewardlePayConfig = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/rewardlepay/config/business?businessid=${state?.currentBusiness?.BusinessId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + businessToken
      }
    };

    axios
      .request(config)
      .then((response) => {
        setConfigData(response?.data);
        getTransactions(filterTransactionByName, null, response?.data);
        getGraphsValue(response?.data);
        getSettlement(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getTransactions = async (
    filterByName: string,
    IsSalesOrTransactions = null,
    data = { ...configData }
  ) => {
    if (IsSalesOrTransactions === "Total Sales") {
      setIsTotalSalesLoading(true);
    } else if (IsSalesOrTransactions === "Total Transactions") {
      setIsTotalTransactionsLoading(true);
    } else {
      setIsTotalSalesLoading(true);
      setIsTotalTransactionsLoading(true);
    }

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/rewardlepay/dashboard/summary/${filterByName}?businessid=${state?.currentBusiness?.BusinessId}&timezone=${data?.BusinessTimeZone}`,
      headers: {
        Authorization: "Bearer " + businessToken
      }
    };

    axios
      .request(config)
      .then((response) => {
        if (IsSalesOrTransactions) {
          let newData = { ...transactionData };
          if (IsSalesOrTransactions === "Total Sales") {
            newData.TransactionsValue = response?.data?.TransactionsValue;
            setTransactionData(newData);
          } else if (IsSalesOrTransactions === "Total Transactions") {
            newData.Transactions = response?.data?.Transactions;
            setTransactionData(newData);
          } else {
            setTransactionData(response.data);
            setIsTotalSalesLoading(false);
            setIsTotalTransactionsLoading(false);
          }
        } else {
          setTransactionData(response.data);
        }
        setIsTotalSalesLoading(false);
        setIsTotalTransactionsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsTotalSalesLoading(false);
        setIsTotalTransactionsLoading(false);
      });
  };

  const getSettlement = (data: any) => {
    setIsSettlementLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/rewardlepay/dashboard/settlements?businessid=${state?.currentBusiness?.BusinessId}&timezone=${data?.BusinessTimeZone}`,
      headers: {
        Authorization: "Bearer " + businessToken
      }
    };

    axios
      .request(config)
      .then((response) => {
        setSettlementData(response?.data);
        setIsSettlementLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsSettlementLoading(false);
      });
  };

  const getGraphsValue = (data: any, filterName = "TransactionsValue") => {
    setAnalyticsIsLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/rewardlepay/dashboard/summary?businessid=${state?.currentBusiness?.BusinessId}&timezone=${data?.BusinessTimeZone}&days=10`,
      headers: {
        Authorization: "Bearer " + businessToken
      }
    };

    axios
      .request(config)
      .then((response) => {
        let data = [...response?.data];
        let dates: any = [];
        let seriesData: any = [];
        data?.map((item) => {
          if (item?.Date) {
            let formatedDate = formatDate(item?.Date);
            dates.push(formatedDate);
          }

          if (
            filterName === "TransactionsValue" ||
            filterName === "SettlementValue"
          ) {
            let value = item?.SummaryData[filterName]
              ? item?.SummaryData[filterName] / 100
              : 0;
            seriesData.push(value);
          } else {
            let value = item?.SummaryData[filterName]
              ? item?.SummaryData[filterName]
              : 0;
            seriesData.push(value);
          }
        });
        let newOptions = { ...options };
        newOptions.xaxis.categories = dates;

        setOptions(newOptions);
        let newSeries = [...series];
        newOptions.yaxis.labels.formatter = function (value: any) {
          const formattedValue =
            filterName === "TransactionsValue" ||
            filterName === "SettlementValue"
              ? `$${value.toFixed(2)}`
              : value.toString();

          return formattedValue;
        };
        newSeries[0].data = seriesData;
        setSeries(newSeries);
        setAnalyticsIsLoading(false);
      })
      .catch((error) => {
        setAnalyticsIsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    if (state?.currentBusiness?.BusinessId) getRewardlePayConfig();
  }, [state?.currentBusiness?.BusinessId]);

  return (
    <>
      <Breadcrumbs
        heading={state?.user?.displayName ? `${state?.user?.displayName}` : ""}
        subHeading="Welcome back to Rewardle"
        docs={null}
      />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <CardContainer
            title={"Total Sales"}
            totalNumber={
              transactionData?.TransactionsValue
                ? `$${(transactionData?.TransactionsValue / 100)?.toFixed(2)}`
                : "$0.00"
            }
            isVisibleDropDownButton={true}
            getTransactions={getTransactions}
            loading={isTotalSalesLoading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardContainer
            title={"Total Transactions"}
            totalNumber={
              transactionData?.Transactions ? transactionData?.Transactions : 0
            }
            isVisibleDropDownButton={true}
            getTransactions={getTransactions}
            loading={isTotalTransactionsLoading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardContainer
            title={"Settlement"}
            totalNumber={
              settlementData?.SettlementValue
                ? `$${(settlementData?.SettlementValue / 100)?.toFixed(2)}`
                : "$0.00"
            }
            isVisibleDropDownButton={false}
            subTitle={
              settlementData?.SettlementText
                ? settlementData?.SettlementText
                : ""
            }
            loading={isSettlementLoading}
          />
        </Grid>
      </Grid>

      <Card sx={{ mt: 2, padding: "20px" }}>
        <CardActions>
          <div>
            <CartTitleTypography>{chartFilterName}</CartTitleTypography>
            <TypographySubTitile>{"By Day"}</TypographySubTitile>
          </div>

          <BoxOption>
            <ButtonGroup
              variant="contained"
              aria-label="split button"
              className={chartFilterName === "Sales" ? "active" : ""}
              onClick={() => {
                setChartFilterName("Sales");
                getGraphsValue(configData, "TransactionsValue");
              }}
            >
              <TypographyButtonSlectedValue>
                {"Sales"}
              </TypographyButtonSlectedValue>
            </ButtonGroup>
            <ButtonGroup
              variant="contained"
              className={chartFilterName === "Transactions" ? "active" : ""}
              aria-label="split button"
              onClick={() => {
                setChartFilterName("Transactions");
                getGraphsValue(configData, "Transactions");
              }}
            >
              <TypographyButtonSlectedValue>
                {"Transactions"}
              </TypographyButtonSlectedValue>
            </ButtonGroup>
            <ButtonGroup
              variant="contained"
              className={chartFilterName === "Settlements" ? "active" : ""}
              aria-label="split button"
              onClick={() => {
                setChartFilterName("Settlements");
                getGraphsValue(configData, "SettlementValue");
              }}
            >
              <TypographyButtonSlectedValue>
                {"Settlements"}
              </TypographyButtonSlectedValue>
            </ButtonGroup>
          </BoxOption>
        </CardActions>

        <Box sx={{ mt: 4, height: "350px", padding: "10px" }}>
          {/* <TypographyChartTitile>{`${chartFilterName} by Day`}</TypographyChartTitile> */}
          {series[0]?.data?.length > 0 && !analyticsIsLoading ? (
            <Analytics options={options} series={series} />
          ) : (
            <Loader />
          )}
        </Box>
      </Card>
    </>
  );
};

export default React.memo(Dashboard);
